<payee-popup [onCancel]="cancel">
  <ng-template #payeePopupTitleTemplate>
    <h1>Státusz megváltoztatása</h1>
  </ng-template>
  <ng-template #payeePopupDescriptionTemplate></ng-template>

  @if (dialogData()) {
    <form
      class="overwrite-state-form"
      [formGroup]="form"
    >
      @for (process of activeProcesses(); track process.id) {
        <ng-container
          [ngTemplateOutlet]="processFormTemplate"
          [ngTemplateOutletContext]="{ $implicit: process }"
        ></ng-container>
      }

      @if (closedProcesses().length > 0) {
        <mat-expansion-panel class="closed-processes-panel">
          <mat-expansion-panel-header>
            <mat-panel-title>Lezárt folyamatok ({{ closedProcesses().length }})</mat-panel-title>
          </mat-expansion-panel-header>

          <div class="closed-processes">
            @for (process of closedProcesses(); track process.id) {
              <ng-container
                [ngTemplateOutlet]="processFormTemplate"
                [ngTemplateOutletContext]="{ $implicit: process }"
              ></ng-container>
            }
          </div>
        </mat-expansion-panel>
      }

      @if (deletedProcesses().length > 0) {
        <mat-expansion-panel class="deleted-processes-panel">
          <mat-expansion-panel-header>
            <mat-panel-title>Törölt folyamatok ({{ deletedProcesses().length }})</mat-panel-title>
          </mat-expansion-panel-header>

          <div class="deleted-processes">
            @for (process of deletedProcesses(); track process.id) {
              <div class="process-form">
                <div class="process-header">
                  <div class="process-label">
                    <span>{{ process.label }}</span>
                    <span
                      class="current-state-badge"
                      [class.closed-badge]="process.state.isClosed"
                    >
                      Törlés előtti állapot: {{ process.state.label }}
                    </span>
                  </div>

                  <button
                    payee-mini-icon-button
                    type="button"
                    color="white"
                    aria-label="Alfolyamat visszaállítása"
                    title="Alfolyamat visszaállítása"
                    [disabled]="loading"
                    (click)="restoreSubprocess(process.id)"
                  >
                    <payee-icon name="arrow-left-grey"></payee-icon>
                  </button>
                </div>
              </div>
            }
          </div>
        </mat-expansion-panel>
      }

      <ng-template
        #processFormTemplate
        let-process
      >
        <div class="process-form">
          <div class="process-header">
            <div class="process-label">
              <span>{{ process.label }}</span>
              <span
                class="current-state-badge"
                [class.closed-badge]="process.state.isClosed"
              >
                Jelenleg: {{ process.state.label }}
              </span>
              @if (showIds[process.id]?.has(process.state.label)) {
                <span class="current-state-id-badge">
                  {{ process.state.id }}
                </span>
              }
            </div>

            @if (!process.isStart) {
              <button
                payee-mini-icon-button
                type="button"
                color="white"
                aria-label="Alfolyamat törlése"
                title="Alfolyamat törlése"
                [disabled]="loading"
                (click)="deleteSubprocess(process.id)"
              >
                <payee-icon name="trash-red"></payee-icon>
              </button>
            }
          </div>

          <payee-form-field width="max">
            <payee-autocomplete
              [formControl]="getProcessControl(process.id)"
              [options]="process.states"
              [displayWith]="stateDisplayWith"
              [clearable]="false"
              [requireSelection]="true"
              [showAllOptionsOnFocus]="true"
            >
              <ng-template
                #optionTemplate
                let-option
              >
                <div class="state-option">
                  <div class="state-label">{{ option?.label }}</div>
                  @if (showIds[process.id]?.has(option.label)) {
                    <div class="state-id">
                      {{ option?.id }}
                    </div>
                  }
                </div>
              </ng-template>
            </payee-autocomplete>
          </payee-form-field>
        </div>
      </ng-template>
    </form>
  }

  <ng-template #payeePopupSubmitTemplate>
    <button
      payee-button
      width="max"
      [disabled]="loading"
      (click)="submit()"
    >
      Mentés
    </button>
  </ng-template>
</payee-popup>
